import { useIntl } from 'react-intl';

import messages from '@/components/emotion-detector/messages';

import { PreviewImage, PreviewOverlay } from '../styles';

interface PreviewOverlayComponentProps {
	preview: string;
}

export default function PreviewOverlayComponent({ preview }: PreviewOverlayComponentProps) {
	const { formatMessage } = useIntl();

	return (
		<PreviewOverlay>
			<PreviewImage src={preview} alt={formatMessage(messages.cameraCapturePreviewAlt)} />
		</PreviewOverlay>
	);
}
